import React, { useRef, useEffect, useState } from 'react';

const Classic = ({ initialData = { simchas: [] }, title = 'שמחות בקהילה', showTitle = true, bgColor }) => {
  const contentRef = useRef(null);
  const containerRef = useRef(null);
  const [needsScroll, setNeedsScroll] = useState(false);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const simchas = (initialData.simchas || []).filter(
    s => !s.expiryDate || new Date(s.expiryDate) > now
  );

  useEffect(() => {
    const checkScroll = () => {
      if (containerRef.current) {
        const containerHeight = containerRef.current.clientHeight;
        const itemEl = containerRef.current.querySelector('[data-simcha-item]');
        const itemHeight = itemEl?.offsetHeight || 0;
        const contentHeight = simchas.length * (itemHeight + 0);
        setNeedsScroll(contentHeight > containerHeight + containerHeight * 0.1);
      }
    };
    const timer = setTimeout(checkScroll, 100);
    const ro = new ResizeObserver(checkScroll);
    if (containerRef.current) ro.observe(containerRef.current);
    return () => { clearTimeout(timer); ro.disconnect(); };
  }, [simchas]);

  const getLabel = (type, customType) => {
    const map = {
      birth_boy: 'הולדת הבן', birth_girl: 'הולדת הבת',
      grandchild_boy: 'הולדת נכד', grandchild_girl: 'הולדת נכדה',
      engagement_boy: 'אירוסי הבן', engagement_girl: 'אירוסי הבת',
      wedding_boy: 'חתונת הבן', wedding_girl: 'חתונת הבת',
      bar_mitzvah: 'בר מצווה', other: customType || 'שמחה',
    };
    return map[type] || customType || 'שמחה';
  };

  const boldLabel = (type, label, boldWords) => {
    if (type !== 'other') return <strong>{label}</strong>;
    if (!boldWords?.length) return label;
    return label.split(/(\s+)/).map((w, i) =>
      boldWords.includes(w.trim()) && w.trim() ? <strong key={i}>{w}</strong> : w
    );
  };

  const renderCard = (simcha, keyPrefix = '', isOriginal = true) => {
    const label = getLabel(simcha.type, simcha.customType);
    return (
      <div
        key={`${keyPrefix}${simcha.id}`}
        {...(isOriginal && { 'data-simcha-item': true })}
        style={{
          padding: '10px 6px',
          textAlign: 'center',
          borderBottom: '1px solid rgba(212,175,55,0.22)',
        }}
      >
        <div style={{ color: '#d4af37', fontSize: '0.62em', letterSpacing: '0.18em', marginBottom: '3px' }}>
          {boldLabel(simcha.type, label, simcha.customTypeBold)}{simcha.celebrant ? ` · ${simcha.celebrant}` : ''}
        </div>
        <div style={{ color: '#ffffff', fontWeight: 700, fontSize: '0.9em', letterSpacing: '0.03em' }}>
          {simcha.name}
        </div>
        {simcha.additionalText && (
          <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.65em', fontStyle: 'italic', marginTop: '3px' }}>
            {simcha.additionalText}
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={{
      padding: '12px',
      direction: 'rtl',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      backgroundColor: bgColor || '#1a3352',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{
          textAlign: 'center',
          marginBottom: '10px',
          paddingBottom: '8px',
          borderBottom: '1px solid rgba(212,175,55,0.4)',
        }}>
          <h3 style={{
            margin: 0,
            color: '#d4af37',
            fontWeight: 700,
            fontSize: '0.875em',
            letterSpacing: '0.12em',
          }}>
            ✦&nbsp; {title} &nbsp;✦
          </h3>
        </div>
      )}

      <div ref={containerRef} style={{ overflow: 'hidden', flex: 1, position: 'relative' }}>
        {simchas.length === 0 ? (
          <div style={{ textAlign: 'center', color: 'rgba(212,175,55,0.55)', fontSize: '0.8em', padding: '10px' }}>
            אין שמחות כרגע
          </div>
        ) : (
          <>
            {needsScroll && (
              <style>
                {`@keyframes scrollSimchasClassic {
                  0%   { transform: translateY(0); }
                  100% { transform: translateY(calc(-100% / 3)); }
                }`}
              </style>
            )}
            <div ref={contentRef} style={{ animation: needsScroll ? 'scrollSimchasClassic 30s linear infinite' : 'none' }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {simchas.map(s => renderCard(s, '', true))}
                {needsScroll && simchas.map(s => renderCard(s, 'dup1-', false))}
                {needsScroll && simchas.map(s => renderCard(s, 'dup2-', false))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Classic;
